// Periods tab (slice C: month close, reopen and year lock). Stub from LP-309 S0; slice C owns this file.
// BooksPage lists the tab only once this file exports enabled = true; it receives
// { me, accounts, deals, reloadShared, onGo } like every Books tab.

export const enabled = false;

export default function PeriodsTab() {
  return null;
}
